import { gatewayAxios } from 'util/Api';

import {
  SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  FETCH_PROCESSING_SUMMARY_START,
  FETCH_PROCESSING_SUMMARY_ERROR,
  FETCH_PROCESSING_SUMMARY_SUCCESS,
  ADD_PROCESSING_SUMMARY_ERROR,
  ADD_PROCESSING_SUMMARY_START,
  ADD_PROCESSING_SUMMARY_SUCCESS,
  DELETE_PROCESSING_SUMMARY_START,
  DELETE_PROCESSING_SUMMARY_SUCCESS,
  DELETE_PROCESSING_SUMMARY_ERROR,
  UPDATE_PROCESSING_SUMMARY_START,
  UPDATE_PROCESSING_SUMMARY_SUCCESS,
  UPDATE_PROCESSING_SUMMARY_ERROR,
} from '../../constants/ActionTypes';

export const getProcessingSummaryById = (id) => (dispatch) => {
  dispatch({ type: FETCH_PROCESSING_SUMMARY_START });
  gatewayAxios.get(`/processing-summary/${id}`)
    .then((axiosResponse) => {
      const response = axiosResponse?.data;
      const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
      const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
      const data = { data: response.data, currentPage, totalItems };

      dispatch({ type: FETCH_PROCESSING_SUMMARY_SUCCESS, payload: data });
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
      }
      dispatch({ type: FETCH_PROCESSING_SUMMARY_ERROR });
      console.error(error);
    });
};

export const getProcessingSummaries = (params) => (dispatch) => {
  dispatch({ type: FETCH_PROCESSING_SUMMARY_START });
  gatewayAxios.get(`/processing-summary/${params ? `?${params}` : ''}`).then(({ data, headers }) => {
    dispatch({
      type: FETCH_PROCESSING_SUMMARY_SUCCESS,
      payload: data,
      meta: {
        page: Number(headers['content-range'].split('-')[0]),
        pageTotal: Number(headers['content-range'].split('/')[1]),
      },
    });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_PROCESSING_SUMMARY_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const addProcessingSummary = (paymentMethod) => (dispatch) => {
  dispatch({ type: ADD_PROCESSING_SUMMARY_START });
  gatewayAxios.post('/processing-summary', paymentMethod).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response.data && response.data.name !== 'MongoError') {
      dispatch({ type: ADD_PROCESSING_SUMMARY_SUCCESS, payload: response.data });
      dispatch({ type: SHOW_MESSAGE, payload: `Added payment method: ${response.data.name}` });
    } else {
      dispatch({ type: ADD_PROCESSING_SUMMARY_ERROR, payload: response.data.name });
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble adding this" });
      console.error('Error: ', response.data.name);
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: ADD_PROCESSING_SUMMARY_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const deleteProcessingSummary = (paymentMethodId) => (dispatch) => {
  dispatch({ type: DELETE_PROCESSING_SUMMARY_START });
  gatewayAxios.delete(`/processing-summary/${paymentMethodId}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: DELETE_PROCESSING_SUMMARY_SUCCESS, payload: paymentMethodId });
    dispatch({ type: SHOW_MESSAGE, payload: response.message });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble deleting this" });
    }
    dispatch({ type: DELETE_PROCESSING_SUMMARY_ERROR });
    console.error('Error: ', error.message);
  });
};

export const updateProcessingSummary = (paymentMethodId, values) => (dispatch) => {
  dispatch({ type: UPDATE_PROCESSING_SUMMARY_START });
  gatewayAxios.put(`/processing-summary/${paymentMethodId}`, values).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: UPDATE_PROCESSING_SUMMARY_SUCCESS, payload: response.data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Succesfully updated payment method' });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble updating this" });
    }
    dispatch({ type: UPDATE_PROCESSING_SUMMARY_ERROR });
    console.error('Error: ', error.message);
  });
};
